import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4438b1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "circle-logo",
  style: {"height":"128px","width":"128px","object-fit":"contain"},
  src: "/../assets/circle-logo.png"
}, null, -1))
const _hoisted_3 = { class: "px-2 body-1" }
const _hoisted_4 = { class: "px-2 body-1" }
const _hoisted_5 = { class: "px-2 w100 pt-4" }
const _hoisted_6 = { class: "px-2 body-1" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "px-2 w100 pt-4" }
const _hoisted_9 = { class: "px-2 body-1" }
const _hoisted_10 = { style: {"height":"250px","width":"250px"} }
const _hoisted_11 = { class: "px-2 w100 pt-4" }
const _hoisted_12 = {
  key: 1,
  class: "ion-text-center o-87 pt-4"
}
const _hoisted_13 = {
  key: 2,
  class: "px-2 body-2 w100 mt-2"
}
const _hoisted_14 = { class: "px-4" }
const _hoisted_15 = {
  key: 4,
  class: "px-2 body-2 w100"
}
const _hoisted_16 = { class: "px-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Enable Notifications", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Interval", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Daily")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Weekly")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Monthly")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "o-7 ma-0" }, " Notifications are only supported on the mobile version ", -1))
const _hoisted_23 = { style: {"display":"flex","flex-direction":"column","width":"100%","z-index":"3"} }
const _hoisted_24 = { class: "w100 flex" }
const _hoisted_25 = {
  class: "my-pointer my-underline",
  style: {"width":"100%","text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close_button = _resolveComponent("close-button")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_wellness_circle = _resolveComponent("wellness-circle")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_region_selector = _resolveComponent("region-selector")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, null, {
    default: _withCtx(() => [
      (!_ctx.wizardCompleted)
        ? (_openBlock(), _createBlock(_component_close_button, {
            key: 0,
            onClick: _ctx.close
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_swiper, {
          onActiveIndexChange: _ctx.moop,
          onSwiper: _ctx.onSwiper,
          style: {"height":"calc(100% - 96px)","max-height":"calc(100vh - 96px)","overflow-y":"scroll","padding-left":"16px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_swiper_slide, { class: "pa-4 full-height flex" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t("wizard.welcomeTitle")), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("wizard.welcomeBody1")), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("wizard.welcomeBody2")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, {
              class: "pa-4 full-height flex ion-text-start",
              style: {"justify-content":"flex-start"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t("wizard.howItWorks")), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("wizard.wellnessWhy")), 1),
                _createVNode(_component_ion_grid, { style: {"max-height":"150px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.circles, (circle) => {
                          return (_openBlock(), _createBlock(_component_ion_col, {
                            size: "3",
                            "size-xs": "3",
                            "size-sm": "3",
                            key: circle
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                alt: "circle-category",
                                style: {"height":"128px","width":"128px"},
                                src: '/../assets/' + circle + '-circle.png'
                              }, null, 8, _hoisted_7)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, { class: "pa-4 full-height flex ion-text-start" }, {
              default: _withCtx(() => [
                _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.$t("wizard.checkInTitle")), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("wizard.checkIns")), 1),
                _createVNode(_component_ion_grid, { class: "pa-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, { class: "ion-justify-content-center pt-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, { size: "auto" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_wellness_circle, {
                                scale: "0.9",
                                size: 250,
                                one: 99,
                                two: 66,
                                three: 23,
                                four: 45
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, { class: "py-4 px-2 full-height flex ion-text-start" }, {
              default: _withCtx(() => [
                _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.$t("wizard.userPrefs")), 1),
                _createVNode(_component_ion_grid, { class: "pa-0" }, {
                  default: _withCtx(() => [
                    (_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_ion_row, {
                          key: 0,
                          style: {"min-height":"104px","height":"104px"},
                          class: "ion-justify-content-center pa-4 flex"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_spinner, {
                              style: {"transform":"scale(2)"},
                              class: "auto",
                              name: "crescent",
                              color: "primary"
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_12, " updating account... "))
                      : _createCommentVNode("", true),
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("wizard.setLocalRegion")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_ion_row, { key: 3 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, {
                              size: "8",
                              "size-xs": "12"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("wizard.localRegionDesc")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_col, {
                              size: "4",
                              "size-xs": "12",
                              class: "flex mb-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_region_selector, {
                                  trigger: _ctx.activeIndex == 3
                                }, null, 8, ["trigger"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("wizard.enableReminders")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_ion_row, { key: 5 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, {
                              size: "10",
                              "size-xs": "12"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("wizard.enableRemindersDesc")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_col, {
                              size: "2",
                              "size-xs": "6",
                              class: "flex-column"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _hoisted_17
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_toggle, {
                                  class: "my-2 pl-2",
                                  disabled: _ctx.loading2 || !_ctx.notificationsPossible,
                                  modelValue: _ctx.notificationsEnabled,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.notificationsEnabled) = $event)),
                                  onClick: _ctx.toggleNotifications
                                }, null, 8, ["disabled", "modelValue", "onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_col, {
                              size: "12",
                              "size-xs": "6",
                              class: "flex-column"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _hoisted_18
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_select, {
                                  interface: "popover",
                                  modelValue: _ctx.interval,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.interval) = $event)),
                                  disabled: _ctx.loading2 || !_ctx.notificationsEnabled,
                                  onIonChange: _ctx.toggleInterval
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_select_option, { value: "daily" }, {
                                      default: _withCtx(() => [
                                        _hoisted_19
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_select_option, { value: "weekly" }, {
                                      default: _withCtx(() => [
                                        _hoisted_20
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_select_option, { value: "monthly" }, {
                                      default: _withCtx(() => [
                                        _hoisted_21
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled", "onIonChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.loading && !_ctx.notificationsPossible)
                      ? (_openBlock(), _createBlock(_component_ion_row, {
                          key: 6,
                          class: "pa-4"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_row, { class: "pa-4" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onActiveIndexChange", "onSwiper"]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_ion_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeIndex == 3 ? _ctx.onSubmit() : _ctx.slideForward())),
              expand: "full",
              disabled: _ctx.loading,
              color: "primary",
              class: "auto my-pointer mr-2",
              style: {
              width: '400px',
              'max-width': '78vw',
            }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.activeIndex == 3 ? "SUBMIT" : "NEXT"), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeIndex == 0 ? _ctx.logout() : _ctx.slideBack()))
            }, _toDisplayString(_ctx.activeIndex == 0 ? "Logout" : "Back"), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}